const LEGACY_PATHS = {
    lobby: "/lobby",
    profile: "/profile",
    players: "/players",
    leaderboard: "/leaderboard",
    account: "/account",
};

const V2_PATHS = {
    lobby: "/lobby-v2",
    profile: "/profile-v2",
    leaderboard: "/leaderboard-v2",
    settings: "/settings",
};

function normalizePathname(pathname) {
    if (!pathname || pathname === "/") {
        return "/";
    }

    return pathname.replace(/\/+$/, "") || "/";
}

export function isLobbyV2Path(pathname) {
    return normalizePathname(pathname) === V2_PATHS.lobby;
}

export function isLeaderboardV2Path(pathname) {
    return normalizePathname(pathname) === V2_PATHS.leaderboard;
}

export function isProfileV2Path(pathname) {
    return normalizePathname(pathname).startsWith(`${V2_PATHS.profile}/`);
}

export function isSettingsV2Path(pathname) {
    const normalized = normalizePathname(pathname);
    return (
        normalized === V2_PATHS.settings ||
        normalized.startsWith(`${V2_PATHS.settings}/`) ||
        normalized === "/settings-v2" ||
        normalized.startsWith("/settings-v2/")
    );
}

export function isV2Path(pathname) {
    return (
        isLobbyV2Path(pathname) ||
        isLeaderboardV2Path(pathname) ||
        isProfileV2Path(pathname) ||
        isSettingsV2Path(pathname)
    );
}

export function toLobbyPath(pathname) {
    return isV2Path(pathname) ? V2_PATHS.lobby : LEGACY_PATHS.lobby;
}

export function toLeaderboardPath(pathname) {
    return isV2Path(pathname) ? V2_PATHS.leaderboard : LEGACY_PATHS.leaderboard;
}

export function toSettingsPath(pathname) {
    return isV2Path(pathname) ? `${V2_PATHS.settings}/account` : LEGACY_PATHS.account;
}

export function toProfilePath(profileId, pathname) {
    if (!profileId) {
        return null;
    }

    return isV2Path(pathname)
        ? `${V2_PATHS.profile}/${profileId}`
        : `${LEGACY_PATHS.profile}/${profileId}`;
}

function normalizeProfilePath(pathname) {
    const normalized = normalizePathname(pathname);
    if (normalized.startsWith(`${LEGACY_PATHS.profile}/`)) {
        return {
            kind: "profile",
            profileId: normalized.slice(`${LEGACY_PATHS.profile}/`.length),
            isV2: false,
        };
    }
    if (normalized.startsWith(`${V2_PATHS.profile}/`)) {
        return {
            kind: "profile",
            profileId: normalized.slice(`${V2_PATHS.profile}/`.length),
            isV2: true,
        };
    }
    return null;
}

export function toV2EquivalentPath(pathname) {
    const normalized = normalizePathname(pathname);
    if (isV2Path(normalized)) {
        return normalized;
    }

    const profilePath = normalizeProfilePath(normalized);
    if (profilePath?.profileId) {
        return `${V2_PATHS.profile}/${profilePath.profileId}`;
    }

    if (normalized === LEGACY_PATHS.lobby) return V2_PATHS.lobby;
    if (normalized === LEGACY_PATHS.leaderboard) return V2_PATHS.leaderboard;
    if (normalized === LEGACY_PATHS.account) return `${V2_PATHS.settings}/account`;
    return null;
}

export function toLegacyEquivalentPath(pathname) {
    const normalized = normalizePathname(pathname);
    if (!isV2Path(normalized)) {
        return normalized;
    }

    const profilePath = normalizeProfilePath(normalized);
    if (profilePath?.profileId) {
        return `${LEGACY_PATHS.profile}/${profilePath.profileId}`;
    }

    if (normalized === V2_PATHS.lobby) return LEGACY_PATHS.lobby;
    if (normalized === V2_PATHS.leaderboard) return LEGACY_PATHS.leaderboard;
    if (isSettingsV2Path(normalized)) return LEGACY_PATHS.account;
    return null;
}

export { LEGACY_PATHS, V2_PATHS };
